import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency, DateBR } from '../contexts/AuthContext';
import { Plus, CreditCard, Search } from 'lucide-react';

export default function Clientes() {
  const { token } = useAuth();
  const [customers, setCustomers] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', phone: '', address: '', credit_limit: '0', observations: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/customers`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setCustomers(d)).catch(() => {});
  }, [token]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/customers/`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ ...form, credit_limit: parseFloat(form.credit_limit) || 0 }) });
      if (!r.ok) { setMsg('Erro ao salvar'); return; }
      setMsg('Cliente salvo'), setOpen(false);
      fetch(`${API_URL}/customers`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setCustomers(d)).catch(() => {});
    } catch { setMsg('Erro interno'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Clientes</h1>
          <p className="text-gray-600">Cadastro de clientes e controle de crédito</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary"><Plus size={18} /> Novo cliente</button>
      </div>
      {msg && <div className="rounded-lg p-3 text-sm bg-green-50 border border-green-200 text-green-700">{msg}</div>}
      <div className="table-wrap">
        <table className="w-full text-left text-sm">
          <thead><tr className="border-b border-gray-200"><th className="pb-2 text-gray-500">Nome</th><th className="pb-2 text-gray-500">Telefone</th><th className="pb-2 text-gray-500 text-right">Limite</th><th className="pb-2 text-gray-500">Endereço</th></tr></thead>
          <tbody>
            {customers.map(c => (
              <tr key={c.id} className="border-b border-gray-100 last:border-0">
                <td className="py-2 font-medium">{c.name}</td>
                <td className="py-2">{c.phone || '-'}</td>
                <td className="py-2 text-right">{Currency(c.credit_limit)}</td>
                <td className="py-2 text-sm">{c.address || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Novo cliente</h2>
            <form onSubmit={save} className="space-y-3">
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Nome</label><input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Telefone</label><input className="input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Limite de crédito (R$)</label><input className="input" type="number" step="0.01" value={form.credit_limit} onChange={e => setForm({ ...form, credit_limit: e.target.value })} /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Endereço</label><input className="input" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Observações</label><input className="input" value={form.observations} onChange={e => setForm({ ...form, observations: e.target.value })} /></div>
              <div className="flex justify-end gap-2 pt-4">
                <button type="button" onClick={() => setOpen(false)} className="btn-ghost px-4">Cancelar</button>
                <button className="btn-primary">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
